<template>
  <div class="tl-card">
    <div class="tl-toolbar">
      <div class="tl-search-wrap">
        <svg class="tl-search-icon" width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"/>
        </svg>
        <input
          v-model="search"
          class="tl-search-input"
          placeholder="Keresés névre vagy kódra..."
        />
        <button v-if="search" class="tl-search-clear" @click="search = ''">
          <svg width="12" height="12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      <span class="tl-count">{{ filtered.length }} template(s)</span>
    </div>

    <div class="tl-table-wrap">
      <div v-if="loading" class="tl-state">
        <div class="tl-spinner"></div>
        <span>Loading...</span>
      </div>

      <div v-else-if="filtered.length === 0" class="tl-state">
        <svg width="36" height="36" fill="none" stroke="#cbd5e1" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
        </svg>
        <span>{{ search ? 'No results found' : 'No template has been created yet' }}</span>
      </div>

      <table v-else class="tl-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Code</th>
            <th>Context</th>
            <th>Type</th>
            <th class="tl-center">Order</th>
            <th class="tl-center">Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in filtered" :key="item.id">
            <td class="tl-name">{{ item.name }}</td>
            <td><span class="tl-code">{{ item.code }}</span></td>
            <td><span class="tl-badge tl-badge--blue">{{ item.context }}</span></td>
            <td><span class="tl-badge tl-badge--gray">{{ item.type }}</span></td>
            <td class="tl-center tl-muted">{{ item.sort_order }}</td>
            <td class="tl-center">
              <button
                class="tl-toggle"
                :class="{ 'tl-toggle--on': item.is_active }"
                @click="$emit('toggle-active', item)"
              >
                <span class="tl-toggle-thumb"></span>
              </button>
            </td>
            <td>
              <div class="tl-actions">
                <button class="tl-icon-btn" title="Szerkesztés" @click="$emit('edit', item)">
                  <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>
                  </svg>
                </button>
                <button class="tl-icon-btn tl-icon-btn--danger" title="Törlés" @click="$emit('delete', item)">
                  <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TemplateList',

  props: {
    templates: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },

  data() {
    return { search: '' }
  },

  computed: {
    filtered() {
      const q = this.search.toLowerCase().trim()
      if (!q) return this.templates
      return this.templates.filter(t =>
        t.name.toLowerCase().includes(q) || t.code.toLowerCase().includes(q)
      )
    },
  },
}
</script>

<style scoped>
.tl-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0px 0px 5px 0px #00000045;
}

.tl-toolbar {
  padding: 14px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #f1f5f9;
}

.tl-search-wrap {
  position: relative;
  flex: 1;
  max-width: 320px;
}

.tl-search-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  pointer-events: none;
}

.tl-search-input {
  width: 100%;
  padding: 8px 32px 8px 32px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #0f172a;
  background: #f8fafc;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.tl-search-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
  background: #fff;
}
.tl-search-input::placeholder { color: #94a3b8; }

.tl-search-clear {
  position: absolute;
  right: 9px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  padding: 2px;
  display: flex;
  align-items: center;
}
.tl-search-clear:hover { color: #475569; }

.tl-count {
  font-size: 12.5px;
  color: #94a3b8;
  white-space: nowrap;
  margin-left: auto;
}

.tl-table-wrap { overflow-x: auto; }

.tl-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 3rem 1rem;
  color: #94a3b8;
  font-size: 13.5px;
}

.tl-spinner {
  width: 28px;
  height: 28px;
  border: 2.5px solid #e2e8f0;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: tl-spin 0.7s linear infinite;
}
@keyframes tl-spin { to { transform: rotate(360deg); } }

.tl-table {
  width: 100%;
  border-collapse: collapse;
}

.tl-table thead th {
  padding: 10px 18px;
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
  white-space: nowrap;
}

.tl-table tbody tr {
  border-bottom: 1px solid #f8fafc;
  transition: background 0.1s;
}
.tl-table tbody tr:last-child { border-bottom: none; }
.tl-table tbody tr:hover { background: #f8fafc; }

.tl-table td {
  padding: 13px 18px;
  font-size: 13.5px;
  color: #1e293b;
  vertical-align: middle;
}

.tl-name { font-weight: 500; }
.tl-muted { color: #94a3b8; }
.tl-center { text-align: center; }

.tl-code {
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 11.5px;
  color: #475569;
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
}

.tl-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.tl-badge--blue { background: #eff6ff; color: #1d4ed8; }
.tl-badge--gray { background: #f1f5f9; color: #475569; }

.tl-toggle {
  position: relative;
  width: 36px;
  height: 20px;
  border-radius: 20px;
  border: none;
  background: #e2e8f0;
  cursor: pointer;
  transition: background 0.2s;
  padding: 0;
}
.tl-toggle--on { background: #2563eb; }

.tl-toggle-thumb {
  position: absolute;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  top: 3px;
  left: 3px;
  transition: transform 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.15);
}
.tl-toggle--on .tl-toggle-thumb { transform: translateX(16px); }

.tl-actions {
  display: flex;
  gap: 5px;
  justify-content: flex-end;
}

.tl-icon-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;
  border-radius: 7px;
  background: transparent;
  cursor: pointer;
  color: #64748b;
  transition: all 0.15s;
}
.tl-icon-btn:hover { background: #f1f5f9; color: #1e293b; border-color: #cbd5e1; }
.tl-icon-btn--danger:hover { background: #fef2f2; color: #dc2626; border-color: #fecaca; }
</style>